import { useAppTheme } from '@/shared/theme';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material';

export function useSimpleSearchTheme() {
  const { theme } = useAppTheme();
  const tokens = theme.simpleSearch;

  const containerSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.container.gap,
    background: tokens.container.background,
    border: `1px solid ${tokens.container.border}`,
    borderRadius: tokens.container.borderRadius,
    padding: tokens.container.padding,
  };

  const inputSx: SxProps<Theme> = {
    fontSize: tokens.input.fontSize,
    fontFamily: tokens.input.fontFamily,
    flex: 1,
    '& .MuiInputBase-root': {
      fontSize: tokens.input.fontSize,
    },
  };

  const fieldSelectSx: SxProps<Theme> = {
    fontSize: tokens.fieldSelect.fontSize,
    '& .MuiInputBase-root': {
      fontSize: tokens.fieldSelect.fontSize,
    },
  };

  const searchButtonSx: SxProps<Theme> = {
    fontSize: tokens.button.fontSize,
    fontWeight: tokens.button.fontWeight,
    fontFamily: tokens.button.fontFamily,
    background: tokens.button.background,
    color: tokens.button.color,
    minWidth: tokens.button.minWidth,
    textTransform: 'none',
    '&:hover': {
      background: tokens.button.hover,
    },
  };

  return {
    tokens,
    containerSx,
    inputSx,
    fieldSelectSx,
    searchButtonSx,
  };
}
